import { Router } from '@angular/router';
// Third party packages
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
// Custom packages
import { EnvironmentService } from 'src/app/shared/services/environment.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ngx-translate/core";
import * as i3 from "ngx-cookie-service";
import * as i4 from "../services/environment.service";
var LangGuard = /** @class */ (function () {
    /**
     * Class constructor
     */
    function LangGuard(router, translateService, cookieService, environmentService) {
        this.router = router;
        this.translateService = translateService;
        this.cookieService = cookieService;
        this.environmentService = environmentService;
    }
    /**
     * Handle guard logic
     *
     * @since 1.0.0
     *
     * @param route Snapshot of activated route
     */
    LangGuard.prototype.canActivate = function (route) {
        var lang = route.params.lang;
        var langs = this.translateService.getLangs();
        if (langs.includes(lang)) {
            this.cookieService.delete('lang');
            this.cookieService.set('lang', lang, 365, '/', this.environmentService.getFrontEndHost(), this.environmentService.getFrontEndCookieSecure(), 'Strict');
            this.translateService.use(lang);
            return true;
        }
        this.router.navigate(['it', 'errors', '404']);
        return false;
    };
    LangGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LangGuard_Factory() { return new LangGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.TranslateService), i0.ɵɵinject(i3.CookieService), i0.ɵɵinject(i4.EnvironmentService)); }, token: LangGuard, providedIn: "root" });
    return LangGuard;
}());
export { LangGuard };
